var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":"/impressum"}},[_vm._v("Impressum")]),_c('router-link',{attrs:{"to":"/privacy"}},[_vm._v("Datenschutzerklärung")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }